import { render } from "./PostingRecordsBranchDiff.vue?vue&type=template&id=1c976d20&scoped=true&ts=true"
import script from "./PostingRecordsBranchDiff.vue?vue&type=script&lang=ts"
export * from "./PostingRecordsBranchDiff.vue?vue&type=script&lang=ts"

import "./PostingRecordsBranchDiff.vue?vue&type=style&index=0&id=1c976d20&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c976d20"]])

export default __exports__